<div class="page-layout">
  <app-toast></app-toast>

  <app-sidebar></app-sidebar>

  <div class="main-area">
    <app-navbar
      pageTitle="Repositories"
      pageSubtitle="Repositories fetched from the connected GitHub organization."
    ></app-navbar>

    <div class="content">
      <div class="breadcrumb-row">
        <button class="back-btn" (click)="goBack()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </button>

        <div class="breadcrumb">
          <span class="source-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="#0D1121"><path d="M12 0C5.37 0 0 5.37 0 12c0 5.3 3.44 9.8 8.21 11.39.6.11.82-.26.82-.58 0-.29-.01-1.04-.02-2.04-3.34.72-4.04-1.61-4.04-1.61-.55-1.39-1.34-1.76-1.34-1.76-1.09-.75.08-.73.08-.73 1.21.08 1.84 1.24 1.84 1.24 1.07 1.84 2.81 1.3 3.49.99.11-.78.42-1.3.76-1.6-2.67-.3-5.47-1.33-5.47-5.93 0-1.31.47-2.38 1.24-3.22-.12-.3-.54-1.52.12-3.18 0 0 1.01-.32 3.3 1.23a11.5 11.5 0 0 1 6 0c2.29-1.55 3.3-1.23 3.3-1.23.66 1.66.24 2.88.12 3.18.77.84 1.24 1.91 1.24 3.22 0 4.61-2.8 5.63-5.48 5.93.43.37.81 1.1.81 2.22 0 1.6-.01 2.89-.01 3.29 0 .32.22.7.83.58C20.56 21.8 24 17.3 24 12c0-6.63-5.37-12-12-12Z"/></svg>
          </span>
          <span class="active">GitHub</span>
        </div>
      </div>

      <div class="toolbar">
        <div class="toolbar-actions" *ngIf="!isLoadingConnections() && connections().length > 0">
          <select
            class="connection-select"
            [value]="selectedConnectionId()"
            (change)="onConnectionChange($any($event.target).value)">
            <option *ngFor="let c of connections()" [value]="c.id">{{ c.name }} ({{ c.organizationName }})</option>
          </select>
        </div>
        <span class="toolbar-text">
          {{ isLoading() ? 'Loading…' : repositories().length + ' repositories' }}
        </span>
        <div class="toolbar-actions">
          <app-button variant="secondary" size="sm" [disabled]="isLoading() || repositories().length === 0" (clicked)="onViewCompleteGraph()">
            View Complete Graph
          </app-button>
        </div>
      </div>

      <div class="empty-repos" *ngIf="!isLoadingConnections() && connections().length === 0">
        <p>No GitHub connections configured yet. Add one from the Connectors page.</p>
      </div>

      <div class="empty-repos" *ngIf="!isLoadingConnections() && connections().length > 0 && !isLoading() && repositories().length === 0">
        <p>No repositories found. Confirm the GitHub App is installed and has access to at least one repository.</p>
      </div>

      <div class="repo-grid" *ngIf="!isLoadingConnections() && connections().length > 0 && !isLoading()">
        <div class="repo-card" *ngFor="let repo of repositories()">
          <div class="repo-card-header">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="#0D1121"><path d="M12 0C5.37 0 0 5.37 0 12c0 5.3 3.44 9.8 8.21 11.39.6.11.82-.26.82-.58 0-.29-.01-1.04-.02-2.04-3.34.72-4.04-1.61-4.04-1.61-.55-1.39-1.34-1.76-1.34-1.76-1.09-.75.08-.73.08-.73 1.21.08 1.84 1.24 1.84 1.24 1.07 1.84 2.81 1.3 3.49.99.11-.78.42-1.3.76-1.6-2.67-.3-5.47-1.33-5.47-5.93 0-1.31.47-2.38 1.24-3.22-.12-.3-.54-1.52.12-3.18 0 0 1.01-.32 3.3 1.23a11.5 11.5 0 0 1 6 0c2.29-1.55 3.3-1.23 3.3-1.23.66 1.66.24 2.88.12 3.18.77.84 1.24 1.91 1.24 3.22 0 4.61-2.8 5.63-5.48 5.93.43.37.81 1.1.81 2.22 0 1.6-.01 2.89-.01 3.29 0 .32.22.7.83.58C20.56 21.8 24 17.3 24 12c0-6.63-5.37-12-12-12Z"/></svg>
            <span class="repo-name">{{ repo.name }}</span>
            <span class="repo-visibility" *ngIf="repo.isPrivate">Private</span>
          </div>
          <p class="repo-fullname">{{ repo.fullName }}</p>
          <p class="repo-description">{{ repo.description || 'No description provided.' }}</p>
          <p class="repo-language" *ngIf="repo.language">{{ repo.language }}</p>
          <div class="repo-card-actions">
            <app-button
              *ngIf="!isTracked(repo.name)"
              class="ingest-btn"
              variant="secondary"
              size="sm"
              [disabled]="isIngesting(repo.name)"
              (clicked)="ingestRepo(repo.name)">
              {{ isIngesting(repo.name) ? 'Ingesting…' : 'Ingest' }}
            </app-button>

            <app-button *ngIf="isTracked(repo.name)" class="ingest-btn" variant="secondary" size="sm" [disabled]="true">
              {{ isIngesting(repo.name) ? 'Ingesting…' : 'Tracked' }}
            </app-button>

            <ng-container *ngIf="isTracked(repo.name) && !isIngesting(repo.name)">
              <span *ngIf="isCheckingGraph(repo.name)" class="graph-status-text">Checking…</span>

              <ng-container *ngIf="!isCheckingGraph(repo.name)">
                <app-button *ngIf="hasGraph(repo.name)" class="view-graph-btn" variant="secondary" size="sm" [disabled]="isUningesting(repo.name)" (clicked)="onViewGraph(repo.name)">
                  View Graph
                </app-button>
                <div class="no-graph-group" *ngIf="!hasGraph(repo.name)">
                  <span class="graph-status-text no-graph">No Graph</span>
                  <app-button class="retry-btn" variant="secondary" size="sm" [disabled]="isUningesting(repo.name)" (clicked)="retryIngest(repo.name)">
                    Retry
                  </app-button>
                </div>
              </ng-container>

              <app-button
                class="uningest-btn"
                variant="secondary"
                size="sm"
                [disabled]="isUningesting(repo.name)"
                (clicked)="uningestRepo(repo.name)">
                {{ isUningesting(repo.name) ? 'Un-ingesting…' : 'Un-ingest' }}
              </app-button>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-delete-batch-modal
    *ngIf="pendingUningest() as repoName"
    title="Un-ingest repository"
    [message]="'Un-ingest ' + repoName + '? This deletes its nodes from the repository graph and the combined graph, and removes its clone.'"
    confirmLabel="Un-ingest"
    busyLabel="Un-ingesting..."
    [isDeleting]="isUningesting(repoName)"
    (cancel)="cancelUningest()"
    (confirm)="confirmUningest()"
  ></app-delete-batch-modal>
</div>
